<template>
    <div class="blank">
        <group gutter="8">
            <!-- <cell title="《人行征信查询授权（银行）》" @click="nextRoute('percontract')">
                <div slot="right">
                        <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                    </div>
            </cell> -->
            <cell title="《人行征信查询授权（众安）》" @click="nextRoute('contract')">
                <div slot="right">
                        <img class="icon" src="../assets/images/link.png" height="12" width="7" alt="">
                    </div>
            </cell>
        </group>
    </div>
</template>

<script>
    import {
        Group,
        Cell
    } from 'fiui'

    export default {
        components: {
            Group,
            Cell
        },
        beforeRouteEnter (to, from, next) {
            document.title = '征信授权协议'
            next()
        },
        methods: {
            nextRoute (route) {
                this.$router.push(route)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// contractlist.vue?2e4cc46c